<template>
  <v-card rounded :min-height="100" class="my-4" variant="flat" border>
    <v-row>
      <v-spacer />
      <v-btn
        color="primary"
        @click="$emit('cancel-add-side')"
        class="ma-4"
        variant="text"
      >
        Cancel</v-btn
      >
    </v-row>
    <v-row class="mt-7 justify-center">
      {{ `Choose a side to ${action}.` }}
    </v-row>
    <v-row no-gutters class="mb-12 justify-center">
      <side-selector
        v-for="(side, idx) in usableSides"
        :key="idx"
        :side="side"
        @selected="$emit('side-selected', side)"
        class="my-2 mx-3 cursor-display test-side-option"
      />
    </v-row>
  </v-card>
</template>

<script lang="ts">
import { EpigraphicUnitSide } from '@oare/types';
import { defineComponent, PropType } from 'vue';
import SideSelector from './SideSelector.vue';

export default defineComponent({
  props: {
    usableSides: {
      type: Array as PropType<EpigraphicUnitSide[]>,
      required: true,
    },
    action: {
      type: String,
      required: true,
    },
  },
  components: {
    SideSelector,
  },
  emits: ['cancel-add-side', 'side-selected'],
  setup() {
    return {};
  },
});
</script>

<style scoped>
.cursor-display {
  cursor: pointer;
}
</style>
